export default __webpack_public_path__ + "static/media/illust-perspective.c0204736.svg";